<one-input
  appNumericInput
  (hasError)="hasError($event)"
  [label]="'formValues.phoneNumber' | translate"
  (input)="setNumber($event.target.value)"
></one-input>
<div class="one-errors-wrapper" *ngIf="formControl.touched && errors.length">
  <small class="one-error" *ngFor="let error of errors">{{ error }}</small>
</div>
